var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormGroup',[_c('Checkbox',{model:{value:(_vm.values.notify_user_when_added),callback:function ($$v) {_vm.$set(_vm.values, "notify_user_when_added", $$v)},expression:"values.notify_user_when_added"}},[_vm._v("\n    "+_vm._s(_vm.$t('fieldCollaboratorSubForm.notifyUserWhenAdded'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }